<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ $t("sharing.recommend") }}</h3>
		<div class="flex flex-wrap justify-center gap-5">
			<div class="items-center flex flex-col">
				<BaseButton
					@click="$FB.ui({ method: 'share', href: `https://${globalConfig.host + $route.fullPath}` })"
					type="tertiary"
				>
					<BaseIcon icon="ic:outline-facebook" color="#3A599B" class="text-2xl" />
					<span class="ml-4">Facebook</span>
				</BaseButton>
			</div>
			<div class="items-center flex flex-col">
				<BaseButton type="tertiary">
					<ClientOnly>
						<ShareNetwork network="linkedin" :url="pageUrl">
							<div class="flex flex-wrap items-center">
								<div class="flex flex-col">
									<BaseIcon class="text-2xl" icon="mdi:linkedin" color="#0666C3" />
								</div>
								<div class="flex flex-col pl-[10px]">
									<span>LinkedIn</span>
								</div>
							</div>
						</ShareNetwork>
					</ClientOnly>
				</BaseButton>
			</div>
		</div>
		<div class="flex items-center justify-center mt-5 cursor-pointer text-dj-blue" @click="copyLink">
			{{ $t("sharing.send") }}
		</div>
		<div class="flex items-center justify-center has-text-success">
			{{ succesfullCopy }}
		</div>
	</DjBox>
</template>

<script lang="ts">
import { ref, defineComponent } from "vue";

export default defineComponent({
	name: "BaseButton",
	props: {},
	setup(_props) {
		const route = useRoute();
		const succesfullCopy = ref("");
		const { t } = useI18n();

		const pageUrl = ref("");

		onMounted(() => {
			pageUrl.value = `https://${globalConfig.host + route.fullPath}`;
		});

		function copyLink() {
			navigator.clipboard.writeText(`https://${globalConfig.host + route.fullPath}`);
			succesfullCopy.value = t("sharing.copied");
			setTimeout(() => {
				succesfullCopy.value = "";
			}, 2000);
		}
		return {
			copyLink,
			succesfullCopy,
			pageUrl,
		};
	},
});
</script>
